import React from 'react';
import PropTypes from 'prop-types';
import {Footer} from '../index';
import {Heading, HeadingLevel} from 'baseui/heading';
import {Paragraph3} from 'baseui/typography';

import visa from '../../assets/visa.png';
import mastercard from '../../assets/mastercard.jpg';
import {Card, StyledBody, StyledAction} from 'baseui/card';
const CardWrapper = ({children, title, desc, cardType}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}>
      <Card
        overrides={{
          Root: {style: {width: '100%', maxWidth: '450px', marginTop: '30px'}},
        }}>
        <HeadingLevel>
          {cardType == 'mastercard' && (
            <img
              src={mastercard}
              width="170"
              style={{marginTop: '0px', marginBottom: '20px'}}
            />
          )}
          {cardType == 'visa' && (
            <img
              src={visa}
              width="120"
              style={{marginTop: '0px', marginBottom: '20px'}}
            />
          )}
          {!cardType && (
            <Heading marginBottom="5px" styleLevel={5}>
              {title}
            </Heading>
          )}
          <Paragraph3 color="#777" marginTop="0">
            {desc}
          </Paragraph3>
        </HeadingLevel>
        {children}
      </Card>
      <Footer />
    </div>
  );
};

export default CardWrapper;
